import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import Select from 'react-select';
import ALL_PRODUCTIONS_NAMES_QUERY from '../../../../graphql/AllProductionsNames';
import StatsMenu from '../../../../components/StatsMenu';
import Visits from './visits';
import Countries from './countries';
import Referrers from './referrers';
import Users from './users';

class ProductionsAnalytics extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      active: 'visits',
      production: {},
    };
  }

  onChangeStatsType = (type) => {
    this.setState({ active: type });
  };

  onChangeProduction = (production) => {
    this.setState({ production, active: 'visits' });
  };

  render() {
    const { active, production } = this.state;
    return (
      <div className={this.props.className}>
        <h1 className="heading">Analíticas de las producciones</h1>

        <div className="production-stats__selector-wrap">
          <div className="form-group">
            <label>Seleccione una producción</label>
            <Select
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              onChange={this.onChangeProduction}
              name="productions"
              isSearchable
              menuPlacement="bottom"
              menuPosition="fixed"
              placeholder="Seleccione una producción"
              options={this.props.productions}
              value={production}
            />
          </div>
        </div>

        {production.value ? (
          <div className="analytics__main">
            <div className="analytics__sidebar">
              <StatsMenu onChange={this.onChangeStatsType} active={active} />
            </div>
            <div className="analytics__content">
              {active === 'visits' && (
              <Visits id={production.value} />
            )}
              {active === 'countries' && (
              <Countries id={production.value} />
            )}
              {active === 'users' && (
              <Users id={production.value} />
            )}
              {active === 'referrers' && (
              <Referrers id={production.value} />
            )}
            </div>
          </div>) : (
            <p>Debe seleccionar una producción para ver sus estadísticas.</p>
        )}
      </div>
    );
  }
}

ProductionsAnalytics.propTypes = {
  theaterId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ProductionsAnalytics.defaultProps = {
  className: '',
};

const withProductions = graphql(ALL_PRODUCTIONS_NAMES_QUERY, {
  options: ({ theaterId }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      theaterId,
      force: true,
    },
  }),
  props: ({ data }) => ({
    productions: data.allProductions ? data.allProductions.map(i => ({
      value: i.id,
      label: i.name,
    })) : [],
  }),
});

export default withProductions(ProductionsAnalytics);



// WEBPACK FOOTER //
// ./src/containers/Admin/Analytics/Productions/index.js